module.exports = __webpack_public_path__ + "img/lifecell-logo.f2e1a46c.png";